const centsToDollars = (cents: number) => cents / 100;

export default centsToDollars;
